import FormElementReadOnly from "../../../../../global/components/FormElement/FormElementReadOnly/FormElementReadOnly.vue";
import SnapshotIcon from "../../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";
import translate from "../../../../../global/directives/translate";
import PuxButton from "../../../../../global/components/PuxButton/PuxButton.vue";
import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "AdressenTr",
  components: {
    FormElementReadOnly,
    SnapshotIcon,
    PuxButton,
  },
  directives: {
    translate,
  },
  props: {
    address: {
      type: Object,
      required: true,
    },
    statusReadonly: {
      type: Boolean,
      required: true,
    },
    addressList: {
      type: Array,
      required: true,
    },
    htmlRegelNummer: {
      type: String,
      required: true,
    },
    statusSnapshot: {
      type: Boolean,
      required: false,
    },
    statusSnapshotAdd: {
      type: Boolean,
      required: false,
    },
    statusSnapshotDelete: {
      type: Boolean,
      required: false,
    },
    statusSnapshotChanges: {
      type: Boolean,
      required: false,
    },
    statusSnapshotChangesIcon: {
      type: Boolean,
      required: false,
    },
    snapshotDate: {
      type: String,
      required: false,
      default: undefined,
    },
    openModalCreateOrEdit: {
      type: Function,
      required: false,
      default: () => {},
    },
    confirmDeleteAddress: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  computed: {
    idButtonEdit() {
      return `${ this.htmlRegelNummer }_edit_${ this.address.pk }`;
    },

    idButtonDelete() {
      return `${ this.htmlRegelNummer }_delete_${ this.address.pk }`;
    },

    statusShowButtons() {
      return !this.statusReadonly && !this.statusSnapshotDelete && !this.statusSnapshotChanges;
    },

    snapshotIconFirstTdType() {
      if (this.statusSnapshotAdd) {
        return "add";
      }
      if (this.statusSnapshotDelete) {
        return "delete";
      }
      if (this.statusSnapshotChangesIcon) {
        return "changes";
      }
      return "";
    },

    translateVersionTdOptions() {
      return {
        text: this.translateVersionTdText,
        extra: {
          date: this.snapshotDate,
        },
      };
    },

    translateVersionTdText() {
      if (this.statusSnapshotAdd) {
        return "_TXT_AKTUELLE_VERSION_ADDED_COLUMN_{{date}}_";
      }
      if (this.statusSnapshotDelete) {
        return "_TXT_VERSION_REMOVED_COLUMN_{{date}}_";
      }
      if (this.statusSnapshotChanges) {
        return "_TXT_VERSION_MODIFIED_COLUMN_{{date}}_";
      }
      return "_TXT_AKTUELLE_VERSION_";
    },

    classVersion() {
      if (this.statusSnapshotDelete || this.statusSnapshotChanges) {
        return "version-bg";
      }
      return "";
    },

    rowspanFirstTd() {
      return this.statusSnapshotChangesIcon ? 2 : 1;
    },

    statusShowFirstTd() {
      return !(this.statusSnapshotChanges && !this.statusSnapshotChangesIcon);
    },
  },
  methods: {
    getOptionsForReadonly(options) {
      if (options.id === "typ") {
        const OPTIONS = cloneDeep(options);
        OPTIONS.url = "katalog/?key=adresstyp";
        return OPTIONS;
      }
      return options;
    },
  },
};
